import { Injectable, inject, signal, computed } from '@angular/core';
import { LOCAL_STORAGE } from '~core/providers/locale-storage';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private readonly AUTH_KEY = 'dfi_auth_email';
    private localStorage: Storage | null = inject(LOCAL_STORAGE);

    // email dell'utente autenticato: la sua presenza indica lo stato di autorizzazione
    private _authEmail = signal<string | null>(this.getInitialAuthEmail());
    readonly authEmail = this._authEmail.asReadonly();
    readonly isAuthorized = computed<boolean>(() => !!this._authEmail());

    setAuthorized(email: string | null): void {
        const value = email?.trim().toLowerCase() || null;
        this._authEmail.set(value);
        if (this.localStorage) {
            if (value) {
                this.localStorage.setItem(this.AUTH_KEY, value);
            } else {
                this.localStorage.removeItem(this.AUTH_KEY);
            }
        }
    }

    logout(): void {
        this.setAuthorized(null);
    }

    private getInitialAuthEmail(): string | null {
        if (!this.localStorage) return null;
        return this.localStorage.getItem(this.AUTH_KEY) || null;
    }
}
